import { render, staticRenderFns } from "./DatiClinicoStrumentaliIctusEdit.vue?vue&type=template&id=2a564be8&scoped=true"
import script from "./DatiClinicoStrumentaliIctusEdit.vue?vue&type=script&lang=js"
export * from "./DatiClinicoStrumentaliIctusEdit.vue?vue&type=script&lang=js"
import style0 from "./DatiClinicoStrumentaliIctusEdit.vue?vue&type=style&index=0&id=2a564be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a564be8",
  null
  
)

export default component.exports